(() => {
  const SESSION_KEY_CACHE = 'collection_pages';
  let PAGES_CACHE = JSON.parse(sessionStorage.getItem(SESSION_KEY_CACHE)) || [];

  const SESSION_KEY_SCROLLTOP = 'scroll_top';
  let scrollTop = sessionStorage.getItem(SESSION_KEY_SCROLLTOP) || 0;

  let ObserveIntersection = ($node, callback) => {
    let intersectionObserver = new IntersectionObserver(function(entries) {
      // If intersectionRatio is 0, the target is out of view
      // and we do not need to do anything.
      if (entries[0].intersectionRatio <= 0) return;

      if (typeof callback == 'function') {
        callback(entries)
      }
    });

    intersectionObserver.observe($node);
  }

  let ConvertStringToHTML = function (str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  let LoadProductCards = (res) => {
    let $res = ConvertStringToHTML(res);
    let $products = $res.querySelectorAll('.product-item');

    let product_card_class = document.querySelector('.product-item').className;
    let $section = document.querySelector('[data-section-type="collection"]');
    let section_id = $section.dataset.sectionId;

    // add products
    $products.forEach(($product) => {
      // set class of first product to keep consistent grid
      $product.className = product_card_class;
      // add quickshop trigger
      let $quickshopTrigger = $product.querySelector('[data-secondary-action="open-quick-view"]');
      $quickshopTrigger.setAttribute('aria-controls', `modal-quick-view-${ section_id }`);

      document.querySelector('.product-list').insertAdjacentElement('beforeend', $product);
    });

    document.dispatchEvent(new CustomEvent('products:loaded'));

    if (scrollTop) {
      window.scrollTo({
        top: scrollTop
      });
      sessionStorage.removeItem(SESSION_KEY_SCROLLTOP);
    }
  }

  let FetchCollectionAndCache = async (url, next_page_index) => {
    let res = await fetch(url).then(res => res.text());
    let itemCache = PAGES_CACHE.find((item) => item.url == url);
    if (!itemCache) {
      // add page to cache
      PAGES_CACHE.push({
        index: next_page_index,
        url: url,
        res: res
      });
      sessionStorage.setItem(SESSION_KEY_CACHE, JSON.stringify(PAGES_CACHE));
    }
    return res;
  }

  let LoadCollection = (url, next_page_index) => {
    let timeout = scrollTop == 0 ? 1000 : 0;
    return new Promise(async(resolve) => {
      // check if not in cache
      let cachedPage = PAGES_CACHE.find((item => item.url == url));
      if (cachedPage) {
        setTimeout(() => {
          resolve(cachedPage.res);
        }, 0);
      }
      else {
        let response = await FetchCollectionAndCache(url, next_page_index);
        resolve(response);
      }
    });
  }

  let LoadCollectionFromCache = (url) => {
    let cachedPages = PAGES_CACHE;
    let scrollTop = sessionStorage.getItem(SESSION_KEY_SCROLLTOP);
    if (scrollTop) {
      cachedPages = cachedPages.filter((item) => item.url.indexOf(url) !== -1);
      cachedPages.forEach(async (page) => { 
        let collection_res = await LoadCollection(page.url);
        LoadProductCards(collection_res);
      });
    }
    return cachedPages.length !== 0;
  }

  let InitScrollEvents = () => {
    document.querySelectorAll('.product-item:not(.initialized)').forEach(($card) => {
      $card.querySelectorAll('a').forEach(($link) => {
        $link.addEventListener('click', (e) => {
          sessionStorage.setItem(SESSION_KEY_SCROLLTOP, window.pageYOffset);
          $card.classList.add('initialized')
        });
      })
    });
  }

  let InfiniteLoad = () => {
    let $paginateWrapper = document.querySelector('.pagination');
    if (!$paginateWrapper) return;

    // Set full url (to account for filtering)
    $paginateWrapper.dataset.url = `${ window.location.pathname }${ window.location.search }`;

    let url = window.location.pathname;
    LoadCollectionFromCache(url);

    let current_page = JSON.parse($paginateWrapper.dataset.current_page);
    let pages = JSON.parse($paginateWrapper.dataset.pages);
    // preload next page to cache
    if (current_page < pages) {
      let next_page_index = current_page + 1;
      let base_url = $paginateWrapper.dataset.url;
      let next_page_url = `${ base_url }${ base_url.indexOf('?') == -1 ? '?' : '&' }page=${ next_page_index }`; 
      let isCached = PAGES_CACHE.find((item) => item.url == next_page_url);
      if (!isCached) {
        FetchCollectionAndCache(next_page_url, next_page_index);
      }  
    }

    $paginateWrapper.style.opacity = 0;
    ObserveIntersection($paginateWrapper, async (entries) => {
      let current_page = JSON.parse($paginateWrapper.dataset.current_page);
      let pages = JSON.parse($paginateWrapper.dataset.pages);
      if (current_page < pages) {
        let next_page_index = current_page + 1;
        $paginateWrapper.dataset.current_page = next_page_index;
        let base_url = $paginateWrapper.dataset.url;
        let next_page_url = `${ base_url }${ base_url.indexOf('?') == -1 ? '?' : '&' }page=${ next_page_index }`; 
      
        let collection_res = await LoadCollection(next_page_url, next_page_index);
        LoadProductCards(collection_res);  

        // preload super-next page and load to cache
        let super_next_page_index = next_page_index + 1;
        let super_next_page_url = `${ $paginateWrapper.dataset.url }?page=${ super_next_page_index }`; 
        FetchCollectionAndCache(super_next_page_url, super_next_page_index);
      }
    });
  }

  const DOMReady = () => {
    document.addEventListener('products:loaded', (e) => {
      InitScrollEvents();
    });

    document.addEventListener('theme:loading:end', (e) => {
      InfiniteLoad();
      InitScrollEvents();  
    });
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();